export const HEATMAP_COLORS = [
  { background: '#AE1443', foreground: '#FFF' },
  { background: '#CF3E43', foreground: '#FFF' },
  { background: '#DB8968', foreground: '#000' },
  { background: '#EAB68B', foreground: '#000' },
  { background: '#FEE88F', foreground: '#000' },
  { background: '#FFEEAB', foreground: '#000' },
  { background: '#E5EEC0', foreground: '#000' },
  { background: '#BCEBCD', foreground: '#000' },
  { background: '#97E0BE', foreground: '#000' },
  { background: '#79D4A8', foreground: '#000' }
];

export const getHeatmapColor = (n: number) => {
  const index = Math.min(
    HEATMAP_COLORS.length - 1,
    Math.floor(Math.max(0, n) * HEATMAP_COLORS.length)
  );

  return HEATMAP_COLORS[index];
};
